/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getCatalogId } from '@msdyn365-commerce/core';
import { ProductPrice } from '@msdyn365-commerce/retail-proxy';
import { getActivePricesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

/**
 * GetProductActivePrices Input Action
 */
export class GetProductActivePricesInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public productIDs: number[];
    constructor(productIDs: number[]) {
        this.productIDs = productIDs;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetActivePrices`;
    public getCacheObjectType = () => 'GetActivePrices';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetProductActivePricesData {
    activePrices: ProductPrice[];
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getActivePricesAction(
    input: GetProductActivePricesInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetProductActivePricesData> {
    const catalogId = getCatalogId(ctx.requestContext);
    const projectDomain = {
        ChannelId: +ctx.requestContext.apiSettings.channelId,
        CatalogId: catalogId
    };
    const activePricesResponse = await getActivePricesAsync(
        { callerContext: ctx },
        projectDomain,
        input.productIDs,
        new Date(),
        null,
        null,
        true,
        null,
        true
    ).then(productPrices => {
        return productPrices;
    });
    return { activePrices: activePricesResponse };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetProductActivePricesData>>getActivePricesAction,
    id: 'GetProductActivePrices'
});
